(function () {
  'use strict';

  /* ---- mobile nav ---- */
  var navToggle = document.getElementById('nav-toggle');
  var mainNav = document.getElementById('main-nav');
  if (navToggle && mainNav) {
    navToggle.addEventListener('click', function () {
      var open = mainNav.classList.toggle('open');
      navToggle.classList.toggle('open', open);
      navToggle.setAttribute('aria-expanded', open);
    });
  }

  /* ---- scroll reveal ---- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---- toast ---- */
  var toastTimer;
  function showToast(message) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2600);
  }

  /* ---- cart count ---- */
  function bumpCartCount(count) {
    var el = document.getElementById('cart-count');
    if (!el) return;
    el.textContent = count;
    el.classList.remove('bump');
    void el.offsetWidth;
    el.classList.add('bump');
  }

  /* ---- product gallery ---- */
  var thumbs = document.querySelectorAll('.product-thumb');
  var mainImage = document.getElementById('product-main-image');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImage) {
        mainImage.style.opacity = 0;
        setTimeout(function () {
          mainImage.src = thumb.getAttribute('data-full');
          mainImage.style.opacity = 1;
        }, 150);
      }
    });
  });

  /* ---- quantity stepper (product page) ---- */
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      var step = parseInt(btn.getAttribute('data-step'), 10);
      var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
      input.value = next;
    });
  });

  /* ---- variant option selects -> matches variant by option order ---- */
  var variantScript = document.getElementById('product-variants-json');
  var variants = variantScript ? JSON.parse(variantScript.textContent) : [];
  var optionSelects = document.querySelectorAll('.option-select');
  var variantIdInput = document.getElementById('product-variant-id');
  var priceEl = document.getElementById('product-price');

  function selectedOptions() {
    var opts = [];
    optionSelects.forEach(function (sel) { opts.push(sel.value); });
    return opts;
  }

  function matchVariant() {
    if (!optionSelects.length || !variants.length) return;
    var chosen = selectedOptions();
    var match = variants.find(function (v) {
      var vOpts = [v.option1, v.option2, v.option3].filter(Boolean);
      return chosen.every(function (val, i) { return vOpts[i] === val; });
    });
    if (match) {
      if (variantIdInput) variantIdInput.value = match.id;
      if (priceEl) priceEl.textContent = '$' + (match.price / 1).toFixed(2);
      var addBtn = document.getElementById('add-to-cart');
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.querySelector('.btn-label').textContent = match.available ? 'Add to Cart' : 'Sold Out';
      }
    }
  }
  optionSelects.forEach(function (sel) { sel.addEventListener('change', matchVariant); });

  /* ---- add to cart via AJAX ---- */
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var addBtn = document.getElementById('add-to-cart');
      var formData = new FormData(productForm);
      if (addBtn) addBtn.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          showToast('Added to cart');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) { bumpCartCount(cart.item_count); })
        .catch(function (err) {
          showToast((err && err.description) || 'Could not add to cart');
        })
        .finally(function () {
          if (addBtn) addBtn.classList.remove('is-loading');
        });
    });
  }
})();
